import { useSite } from "../../context/SiteContext";
import { Reveal, Overline } from "../Reveal";

export default function WhatWeDo() {
    const { site, tx } = useSite();
    const c = site?.content || {};
    const pillars = c.pillars || [];

    return (
        <section id="what-we-do" data-testid="pillars-section" className="grain relative bg-[#F4F3EF] px-6 py-32 text-[#0A0A0A] md:px-12 md:py-48 lg:px-24">
            <Overline testId="pillars-overline">Our ecosystem — 04</Overline>
            <Reveal>
                <h2 className="font-display mt-6 text-[clamp(3rem,7.5vw,7rem)] leading-[0.85]" data-testid="pillars-title">
                    {tx(c.pillars_title) || "WHAT WE DO"}
                    <span className="text-[#D60024]">.</span>
                </h2>
            </Reveal>

            <div className="mt-20 grid gap-px border border-black/15 bg-black/15 md:grid-cols-3">
                {pillars.map((p, i) => {
                    const title = (p.title || "").replace("+", "");
                    return (
                        <div
                            key={i}
                            data-testid={`pillar-panel-${i}`}
                            data-cursor="plus"
                            className="group flex min-h-[26rem] flex-col justify-between bg-[#F4F3EF] p-8 transition-colors duration-500 hover:bg-[#0A0A0A] hover:text-white md:p-10"
                        >
                            <div>
                                <span className="text-[11px] font-semibold tracking-[0.3em] text-black/40 transition-colors group-hover:text-white/40">
                                    0{i + 1}
                                </span>
                                <h3 className="font-display mt-4 text-5xl leading-none md:text-6xl">
                                    {title}
                                    <span className="inline-block text-[#D60024] transition-transform duration-500 group-hover:rotate-45">+</span>
                                </h3>
                                <p className="mt-6 max-w-xs text-sm leading-relaxed text-black/60 transition-colors group-hover:text-white/60">{tx(p.text)}</p>
                            </div>
                            <ul className="mt-10 space-y-2.5">
                                {(p.items || []).map((item, j) => (
                                    <li key={j} className="flex items-center gap-3 border-t border-black/10 pt-2.5 text-xs font-semibold uppercase tracking-[0.18em] transition-colors group-hover:border-white/15">
                                        <span className="font-display text-[#D60024]">+</span>
                                        {tx(item)}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
